import React, { useState, useEffect } from "react";
import "../../Template02/Combined.css";
import { Link, NavLink } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const togglebutton = () => {
    setToggleMenu(!toggleMenu);
    console.log(toggleMenu); // Toggling the state to show/hide the menu
  };

  return (
    
    <>
      <header className={`blockHeader wb-header ${scrolled ? "sticky" : ""}`}>
        <div className="container boxWidget">
          <div className="logoWidget logo logoTextSettingClass">
            <Link to="/" title="Medisol-Lab">
              <span id="logoTextWrap">
                <span
                  className="websiteLogoName"
                  style={{ fontFamily: "Roboto", fontSize: "25px" }}
                >
                  Medisol Labs
                </span>
                <span
                  className="websiteLogoSlogan"
                  style={{
                    color: "#fff",
                    fontFamily: "Roboto",
                    fontSize: "10px",
                  }}
                >
                  {/* Optional Slogan */}
                </span>
              </span>
            </Link>
          </div>
          <div className="navbar navbar-default navbar-static-top">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                aria-expanded={toggleMenu}
                aria-controls="navbarNav"
                aria-label="Toggle navigation"
                onClick={togglebutton}
              >
                <span className="sr-only">Toggle navigation</span>
                <GiHamburgerMenu
                  style={{ color: "#d10f56", fontSize: "32px" }}
                />
              </button>
            </div>

            <div
              className={`navWidget navbar-collapse ${toggleMenu ? "collapse" : "collapse in"}`}
              id="navbarNav"
            >
              <ul className="parent-nav-ul nav navbar-nav navbar-right">
                <li className="dropdown">
                  <NavLink
                    to="/"
                    className="siteNavLink"
                    activeClassName="active"
                  >
                    HOME
                  </NavLink>
                </li>
                <li className="dropdown">
                  <NavLink
                    to="/about"
                    className="siteNavLink"
                    activeClassName="active"
                  >
                    ABOUT
                  </NavLink>
                </li>
                <li className="dropdown">
                  <NavLink
                    to="/services"
                    className="siteNavLink"
                    activeClassName="active"
                  >
                    SERVICES
                  </NavLink>
                </li>
                <li className="dropdown">
                  <NavLink
                    to="https://www.medisol.in/"
                    className="siteNavLink"
                    activeClassName="active"
                  >
                    MANUFACTURING
                  </NavLink>
                </li>
                <li className="dropdown">
                  <NavLink
                    to="/gallery"
                    className="siteNavLink"
                    activeClassName="active"
                  >
                    GALLERY
                  </NavLink>
                </li>
                <li className="dropdown">
                  <NavLink
                    to="/contact"
                    className="siteNavLink"
                    activeClassName="active"
                  >
                    CONTACT
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
